import StateManager from "../scuba/StateManager";
import LayoutManager from "../scuba/LayoutManager";


// Lecture cookies (pour WPML)
function getCookie(c_name) {
  var c_value = document.cookie,
      c_start = c_value.indexOf(" " + c_name + "=");
  if (c_start == -1) c_start = c_value.indexOf(c_name + "=");
  if (c_start == -1) {
      c_value = null;
  } else {
      c_start = c_value.indexOf("=", c_start) + 1;
      var c_end = c_value.indexOf(";", c_start);
      if (c_end == -1) {
          c_end = c_value.length;
      }
      c_value = unescape(c_value.substring(c_start, c_end));
  }
  return c_value;
}


/* -------------------------
    TEAM V2
------------------------- */

const quickViewButtons = document.querySelectorAll('[data-quick-view]');
const closeButtons = document.querySelectorAll('[data-close]');
const fullwidthCards = document.querySelectorAll('.fullwidth');
let toggle; // Quick view <button>.
let toggleParent; // <li>.
let fullwidth; // Fullwidth card to be "injected".

const openQuickView = (toggle, toggleParent, fullwidth) => {
    toggle.setAttribute('aria-expanded', 'true');
    toggleParent.classList.toggle('is-selected');
    fullwidth.classList.toggle('is-hidden');
    // Make fullwidth card keyboard focusable.
    fullwidth.setAttribute('tabIndex', '0');
};

const closeQuickView = (toggle, toggleParent, fullwidth) => {
    toggle.setAttribute('aria-expanded', 'false');
    toggleParent.classList.toggle('is-selected');
    fullwidth.classList.toggle('is-hidden');
    fullwidth.removeAttribute('tabIndex');
};

quickViewButtons.forEach(quickView => {
    // Add appropriate ARIA attributes for "toggle" behaviour.
    fullwidth = quickView.parentElement.nextElementSibling;
    quickView.setAttribute('aria-expanded', 'false');
    quickView.setAttribute('aria-controls', fullwidth.id);

    quickView.addEventListener('click', (e) => {
        toggle = e.target;
        toggleParent = toggle.parentElement;
        fullwidth = toggleParent.nextElementSibling;

        // Open (or close) fullwidth card.
        if (toggle.getAttribute('aria-expanded') === 'false') {
            // Do we have another fullwidth card already open? If so, close it.
            fullwidthCards.forEach(fullwidthOpen => {
                if (!fullwidthOpen.classList.contains('is-hidden')) {

                  console.log('toggleOpen',fullwidthOpen.previousElementSibling);
                    var toggleParentOpen = fullwidthOpen.previousElementSibling;
                    var toggleOpen = toggleParentOpen.querySelector('[data-quick-view]');
                    $(toggleOpen).empty();
                    if ( getCookie('wp-wpml_current_language') == 'fr' ) {
                      $(toggleOpen).append("(plus)");
                      console.log("FR");
                    } else {
                      $(toggleOpen).append("(read more)");
                      console.log("EN");
                    }
                    closeQuickView(toggleOpen, toggleParentOpen, fullwidthOpen);
                }
            });
            $(toggle).empty();
            if ( getCookie('wp-wpml_current_language') == 'fr' ) {
              $(toggle).append("(moins)");
              console.log("FR");
            } else {
              $(toggle).append("(less)");
              console.log("EN");
            }
            openQuickView(toggle, toggleParent, fullwidth);
        } else {
          $(toggle).empty();
          if ( getCookie('wp-wpml_current_language') == 'fr' ) {
            $(toggle).append("(plus)");
            console.log("FR");
          } else {
            $(toggle).append("(read more)");
            console.log("EN");
          }
          closeQuickView(toggle, toggleParent, fullwidth);
        }
    });
});

closeButtons.forEach(close => {
    close.addEventListener('click', (e) => {
        fullwidth = e.target.parentElement;
        toggleParent = e.target.parentElement.previousElementSibling;
        toggle = toggleParent.querySelector('[data-quick-view]');

        $(toggle).empty();
        $(toggle).append("(plus)");
        closeQuickView(toggle, toggleParent, fullwidth);
        toggle.focus(); // Return keyboard focus to "toggle" button.
    });
});





/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  $(node)
    .find(".team")
    .each(function(i, el) {
      new Grid(el);
    });
});

function Grid(el) {
  var self = this;
  self.$grid = $(".team");
  self.$items = self.$grid.children("li");
  self.current = -1; //current expanded index
  self.previewPos = -1; // top of expanded index (is it a different row ?)
  self.scrollExtra = 0;
  self.marginExpanded = 10;
  self.$window = $(window);
  self.winsize;
  self.$body = $("html, body");
  self.settings = {
    minHeight: 100,
    maxHeight: 300,
    speed: 350,
    easing: "ease"
  };

  self.init();
}

Grid.prototype.init = function() {
  const self = this;
  // save item´s size and offset
  self.saveItemInfo(true);
  // get window´s size
  self.getWinSize();
  // // initialize some events
  self.initEvents();
};

Grid.prototype.saveItemInfo = function(saveHeight) {
  var self = this;
  self.$items.each(function() {
    var $item = $(this);
    $item.data("offsetTop", $item.offset().top);
    if (saveHeight) {
      $item.data("height", $item.height());
    }
  });
};

Grid.prototype.getWinSize = function() {
  var self = this;
  self.winsize = { width: self.$window.width(), height: self.$window.height() };
};

Grid.prototype.initEvents = function() {
  var self = this;
  // when clicking an item, show the preview with the item´s info and large image.
  // close the item if already expanded.
  // also close if clicking on the item´s cross
  self.initItemsEvents(self.$items);
};

Grid.prototype.initItemsEvents = function($items) {
  var self = this;
  $items.each(function(index) {
    $($items[index])
      .on("mouseenter", function(e) {
        var $item = $(this);
        self.showPreview($item);
        return false;
      })
      .on("mouseleave", function(e) {
        self.hidePreview();
        return false;
      });
  });
};

Grid.prototype.showPreview = function($item) {
  var self = this;
  var preview = $.data(this, "preview"),
    // item´s offset top
    position = $item.offsetTop;

  self.scrollExtra = 0;

  // if a preview exists and previewPos is different (different row) from item´s top then close it
  if (typeof preview != "undefined") {
    // not in the same row
    if (self.previewPos !== position) {
      // if position > previewPos then we need to take te current preview´s height in consideration when scrolling the window
      if (position > self.previewPos) {
        self.scrollExtra = preview.height;
      }
      self.hidePreview();
    }
    // same row
    else {
      preview.update($item, self);
      return false;
    }
  }

  // update previewPos
  self.previewPos = position;
  // initialize new preview for the clicked item
  preview = $.data(this, "preview", new Preview($item, self));
  // expand preview overlay
  preview.open(self);
};

Grid.prototype.hidePreview = function() {
  var self = this;
  self.current = -1;
  var preview = $.data(this, "preview");
  preview.close(self);
  $.removeData(this, "preview");
};

function Preview($item, $grid) {
  var self = this;
  self.$item = $item;
  self.expandedIdx = this.$item.index();
  self.create();
  self.update($item, $grid);
}

Preview.prototype.create = function() {
  this.$description = $("<p></p>");

  this.$details = $('<div class="og-details"></div>').append(this.$description);

  this.$previewInner = $('<div class="og-expander-inner"></div>').append(
    this.$details
  );
  this.$previewEl = $('<div class="og-expander"></div>').append(
    this.$previewInner
  );
  // append preview element to the item
  this.$item.append(this.$previewEl);
};

Preview.prototype.update = function($item, $grid) {
  if ($item) {
    this.$item = $item;
  }

  // if already expanded remove class "og-expanded" from current item and add it to new item
  if ($grid.current !== -1) {
    var $currentItem = $grid.$items.eq($grid.current);
    $currentItem.removeClass("og-expanded");
    this.$item.addClass("og-expanded");
    // position the preview correctly
    this.positionPreview($grid);
  }

  // update current value
  $grid.current = this.$item.index();

  // update preview´s content
  var $itemEl = this.$item.children("a"),
    eldata = {
      description: $itemEl.data("description")
    };

  this.$description.html(eldata.description);
};

Preview.prototype.open = function($grid) {
  setTimeout(
    $.proxy(function() {
      // set the height for the preview and the item
      this.setHeights($grid);
      // scroll to position the preview in the right place
      this.positionPreview($grid);
    }, this),
    25
  );
};

Preview.prototype.close = function($grid) {
  var self = this,
    onEndFn = function() {
      self.$item.removeClass("og-expanded");
      self.$previewEl.remove();
      self.$previewEl.css("height", 0);
      self.$item.css("height", 380);
    };

  setTimeout(
    $.proxy(function() {
      if (typeof this.$largeImg !== "undefined") {
        this.$largeImg.fadeOut("fast");
      }
      this.$previewEl.css("height", 0);
      // the current expanded item (might be different from this.$item)
      var $expandedItem = $grid.$items.eq(this.expandedIdx);
      $expandedItem.css("height", 380);

      onEndFn.call();
    }, this),
    25
  );

  return false;
};

Preview.prototype.calcHeight = function($grid) {
  this.height = 300;
  this.itemHeight = 300 + 380 + $grid.marginExpanded;
};

Preview.prototype.setHeights = function($grid) {
  var self = this,
    onEndFn = function() {
      // if (support) {
      //   self.$item.off(transEndEventName);
      // }
      self.$item.addClass("og-expanded");
    };

  this.calcHeight($grid);
  this.$previewEl.css("height", this.height);
  this.$item.css("height", this.itemHeight);

  // if (!support) {
  onEndFn.call();
  // }
};

Preview.prototype.positionPreview = function($grid) {
  // scroll page
  // case 1 : preview height + item height fits in window´s height
  // case 2 : preview height + item height does not fit in window´s height and preview height is smaller than window´s height
  // case 3 : preview height + item height does not fit in window´s height and preview height is bigger than window´s height
  var position = this.$item.offsetTop,
    previewOffsetT = this.$previewEl.offset().top - $grid.scrollExtra,
    scrollVal =
      this.height + this.$item.height() + $grid.marginExpanded <=
      $grid.winsize.height
        ? position
        : this.height < $grid.winsize.height
        ? previewOffsetT - ($grid.winsize.height - this.height)
        : previewOffsetT;

  $grid.$body.animate({ scrollTop: scrollVal }, $grid.settings.speed);
};



// WEBPACK FOOTER //
// ./scripts/components/ExpandingGrid.js